import { PurchaseButton, SoldOutText } from 'components/button/button.styled'
import { LoadingContainer } from 'components/loadingContainer'
import { useImageById } from 'hooks/user/useImage/useImageById'
import { useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { EventDetails } from 'types/Event'
import { formatDateMonth, formatTime } from 'utils/event'

import {
    ActionContainer,
    DateContainer,
    DateDisplay,
    DetailsContainer,
    ImageComponent,
    ImageContainer,
    LocationText,
    Title,
    WrapperColumn,
    WrapperRow,
} from './eventCardUser.style'

interface Props {
    data: EventDetails
    saleIsOver: boolean
    showPurchaseButton: boolean
}

export const EventCardUser = ({ data, saleIsOver, showPurchaseButton }: Props) => {
    const imageSource = data?.custom_image ?? data?.show?.cover_image
    const { data: imageData, isLoading: isImageLoading, error: ImageError } = useImageById(imageSource)
    const navigate = useNavigate()

    const handleRedirect = useCallback(() => {
        navigate(`/musor/${data.show_id}`)
    }, [data.show_id, navigate])

    const handleBuying = useCallback(() => {
        navigate(`/jegyek/vasarlas/${data.event_id}`)
    }, [data.event_id, navigate])

    const formattedDate = useMemo(() => {
        const eventDate = new Date(data.event_date)
        const currentYear = new Date().getFullYear()
        const eventYear = eventDate.getFullYear()

        const formattedMonthDay = formatDateMonth(eventDate)

        if (eventYear !== currentYear) {
            return `${eventYear}. ${formattedMonthDay}`
        }
        return formattedMonthDay
    }, [data.event_date])

    const formattedTime = useMemo(() => formatTime(new Date(data.event_date)), [data.event_date])

    return (
        <LoadingContainer isLoading={isImageLoading} error={ImageError}>
            <ImageContainer onClick={handleRedirect}>
                <ImageComponent alt="show_image" src={imageData?.image_url} />
            </ImageContainer>
            <WrapperColumn>
                <WrapperRow>
                    <DetailsContainer>
                        <Title onClick={handleRedirect}>{data.show.name}</Title>
                        <LocationText>{data.location?.name || 'N/A'}</LocationText>
                        <DateContainer>
                            <DateDisplay>{formattedDate}</DateDisplay>
                            <DateDisplay>{formattedTime}</DateDisplay>
                        </DateContainer>
                    </DetailsContainer>
                    <ActionContainer>
                        {showPurchaseButton &&
                            (saleIsOver ? (
                                <SoldOutText>Az értékesítés lezárult</SoldOutText>
                            ) : (
                                <PurchaseButton onClick={handleBuying}>Jegyvásárlás</PurchaseButton>
                            ))}
                    </ActionContainer>
                </WrapperRow>
            </WrapperColumn>
        </LoadingContainer>
    )
}
